module.exports = __webpack_public_path__ + "img/43_15.ea821c55.png";